export default "__VITE_ASSET__b5e12f0d__"